export default __webpack_public_path__ + "static/trial-9afac6ae4f0fddcad7ee7eba59e898c9.jpg";